<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed" >
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>通知公告</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>
    </div>
    <el-form :inline="true"  style="padding-top:30px"> 
      <div class="flex-r-x">
         <el-button icon="el-icon-plus" size="mini" type="primary" @click="sendNotice" v-if="canSend && activeName=='all'&& q1 == true">发送通知</el-button>
         <el-button icon="el-icon-plus" size="mini" type="primary" @click="sendGG" v-if="canSend && activeName=='gg' && q4 == true">发布公告</el-button>
      </div>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="topTabs" >
            <el-tab-pane label="通知" name="all" v-if="q6 == true">
                <el-table  :data="NoticeList" highlight-current-row v-loading="loading" size="small"    element-loading-text="拼命加载中" style="width: 100%;margin-left:-10px">
               <el-table-column label="发送类型" prop="Title"></el-table-column>
                            <el-table-column label="发送对象" prop="sendType">
                              <template slot-scope="scope" class="flexB">
                                {{sendTypeList[scope.row.sendType-1].TypeName}}
                              </template>
                            </el-table-column>
                            <el-table-column label="发送类型" prop="NoticeType">
                                <template slot-scope="scope" class="flexB">
                                    <span v-if="scope.row.NoticeType==1"> 放假通知 </span>
                                    <span v-if="scope.row.NoticeType==2"> 停课通知 </span>
                                    <span v-if="scope.row.NoticeType !=1 && scope.row.NoticeType !=2"> 其他通知 </span>
                                    </template>
                            </el-table-column>

                            
                             <el-table-column label="发送内容" prop="SContent"></el-table-column>
                             <el-table-column label="发布时间" prop="addTime"></el-table-column>

                            <el-table-column label="操作" fixed="right" width="100">
                                <template slot-scope="scope" class="flexB">
                                    <el-button size="mini" type="info"  @click="deletNoticeClick(scope.row)"  v-if="q2 == true">删除</el-button>
                                </template>
                            </el-table-column>
                </el-table>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </el-tab-pane>
            <el-tab-pane label="公告" name="gg" v-if="q3 == true">
                <el-table class="memberTable" :data="AnnouncementList" size="small" highlight-current-row v-loading="loading" :row-key="row => row.index" >
                    <el-table-column label="公告标题" prop="aTitle"></el-table-column>
                    <el-table-column label="公告内容" prop="aInfo"></el-table-column>
                    <el-table-column label="发布时间" prop="addTime"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                        <template slot-scope="scope" class="flexB">
                            <el-button size="mini" type="info" @click="deletAnnouncementClick(scope.row.ID)"  v-if="q5 == true" >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </el-tab-pane>
    </el-tabs>
          <el-drawer :wrapperClosable= false
            class="normalDrawer"
            title="发送通知"
            direction="ltr"
            size="40%"
            v-loading="loading1"
            :visible.sync="showDrawer"
  
            >
            <div class="drawerForm">
                <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="130px" label-position="right">
                    <!-- {{ruleForm}} -->
                    <el-form-item label="发送对象：" prop="sendType">
                        <el-radio-group v-model="ruleForm.sendType" @change="changeOptions">
                            <el-radio v-for="item in sendTypeList" :label="item.ID" :key="item.index">
                                {{item.TypeName}}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="'选定'+WZYGName+'：'" v-if="showSelectTeacher" prop="NoticeTeacher">
                         <el-button type="text" @click="addeacherIDs" class="set-link">选择{{WZYGName}}</el-button>  
                              <br> 
                          <span >{{ruleForm.TeacherName}}</span> 
                    </el-form-item> 
                    <el-form-item :label="'选定'+WZHYName+'：'" v-if="showSelectMember" prop="NoticeMember">
                      <el-button type="text" @click="addMemberIDs" >选择{{WZHYName}}</el-button>  
                              <br> 
                          <span >{{ruleForm.MemberName}}</span>
                    </el-form-item>
                    <el-form-item label="选定班级：" v-if="showSelectClass" prop="NoticeClass">
                      <span @click="addClassIDs" class="set-link">选择班级</span>  
                              <br> 
                          <span >{{ruleForm.ClassNames}}</span>
                    </el-form-item>

                    <el-form-item v-if="iscdyy==0" label="发送类型：" prop="NoticeType">
                                    <el-radio-group v-model="ruleForm.NoticeType">
                                    <el-radio :label="1">放假通知</el-radio>
                                     <el-radio :label="2">停课通知</el-radio>
                                     <el-radio :label="3">其他通知</el-radio>
                                 </el-radio-group>                 
                       </el-form-item>
                       <el-form-item v-if="iscdyy==1" label="发送类型：" prop="NoticeType">
                                    <el-radio-group v-model="ruleForm.NoticeType">
                                    <el-radio :label="1">放假通知</el-radio>
                                      <el-radio :label="3">其他通知</el-radio>
                                 </el-radio-group>                 
                       </el-form-item>
                    <el-form-item v-if="ruleForm.NoticeType==1" label="标题：" prop="Title">
                        <el-input v-model="ruleForm.Title" placeholder="输入标题"  style="width:90%"></el-input>
                    </el-form-item>
                    <el-form-item  v-if="ruleForm.NoticeType==1" label="放假详情：" prop="SContent">
                        <el-input type="textarea" v-model="ruleForm.SContent"  style="width:90%"></el-input>
                    </el-form-item>
                     <el-form-item v-if="ruleForm.NoticeType==3" label="标题：" prop="Title">
                        <el-input v-model="ruleForm.Title" placeholder="输入标题" style="width:90%"></el-input>
                    </el-form-item>
                    <el-form-item  v-if="ruleForm.NoticeType==3" label="内容：" prop="SContent">
                        <el-input type="textarea" v-model="ruleForm.SContent"  style="width:90%"></el-input>
                    </el-form-item>
                     <el-form-item v-if="ruleForm.NoticeType==2" label="停课原因：" prop="Title">
                        <el-input v-model="ruleForm.Title" placeholder="输入停课原因"  style="width:90%"></el-input>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.NoticeType==2" label="停课时间：" prop="tkTime">
                        <el-date-picker 
                            v-model="ruleForm.tkTime"
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择停课开始时间">
                        </el-date-picker> ~
                           <el-date-picker
                            v-model="ruleForm.tkendTime"
                            align="right"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择停课结束时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item  v-if="ruleForm.NoticeType==2" label="备注：" prop="SContent">
                        <el-input type="textarea" v-model="ruleForm.SContent"  style="width:90%"></el-input>
                    </el-form-item>
                    <el-form-item  v-if="(ruleForm.NoticeType==1 || ruleForm.NoticeType==2)&& iswebview==0" label="微信推送" prop="isPush">
                         <el-switch
                                     v-model="ruleForm.isPush"
                                     on-color="#00A854"
                                    on-text="启动"
                                     on-value="1"
                                     off-color="#F04134"
                                      off-text="禁止"
                                     off-value="0"
                                >
                                    </el-switch>
                             <span v-if="ruleForm.isPush==1" @click="mobaninfo(ruleForm)" class="set-link" >模板详情</span>

                    </el-form-item>
                        <el-form-item label="短信推送" prop="isSms">
                        <el-switch
                            v-model="ruleForm.isSms"
                             on-color="#00A854"
                                    on-text="启动"
                                     on-value="1"
                                     off-color="#F04134"
                                      off-text="禁止"
                                     off-value="0">
                        </el-switch>
                           <span  v-if="ruleForm.isSms==1" @click="mobandxinfo(ruleForm)" class="set-link" >模板详情</span>

                    </el-form-item>  
               
                      
        
                </el-form>
        <div class="demo-drawer__footer flex-r-x"  style="width:40%">
      <div>
          <el-button size="small" @click="showDrawer = false">取消</el-button>
          
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
       @click="onSend('ruleForm')"
            >立即发布</el-button
          >
  </div>
         
        </div>
            </div>
        </el-drawer>
          <el-drawer :wrapperClosable= false
            class="normalDrawer"
            title="发布公告"
            direction="ltr"
            size="40%"
            :visible.sync="showDrawerGG"
       
            >
            <div class="drawerForm">
                <el-form :model="ruleFormGG" ref="ruleFormGG" :rules="rulesGG" label-width="130px" label-position="right">
                    <el-form-item label="标题：" prop="aTitle">
                        <el-input v-model="ruleFormGG.aTitle" placeholder="输入标题" style="width:90%"></el-input>
                    </el-form-item>
                    <el-form-item label="内容：" prop="aInfo">
                        <el-input type="textarea" v-model="ruleFormGG.aInfo" style="width:90%"></el-input>
                    </el-form-item>
                 
                </el-form>
            </div>
                    <div class="demo-drawer__footer flex-r-x"  style="width:40%">
      <div>
          <el-button size="small" @click="showDrawerGG = false">取消</el-button>
          
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
      @click="onSendgg('ruleFormGG')"
            >立即发布</el-button
          >
  </div>
         
        </div>
        </el-drawer>

        <el-dialog
      title="放假通知"
      :visible.sync="dialogtsVisible"
      width="40%"
        >
          <div class="ant-modal-body1">
                   <div>
                       <div class="form-item">
                           <label class="form-item-title">放假通知</label><br>
                           <span class="form-item-content"> <标题> <br>
                            学校：<学校> <br>
                            发布时间：<发布时间> <br>
                            发布人：<发布人> <br>
                            放假详情：<放假详情> <br>
                           </span>
                           </div>
                           </div>
                        </div>

         <span slot="footer" class="dialog-footer1">
        <el-button @click="dialogtsVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
    <el-dialog
      title="短信模板"
      :visible.sync="dialogtsdxVisible"
      width="40%"
        >
          <div class="ant-modal-body1">
                   <div>
                      <span v-if="ruleForm.NoticeType==1">【预约小宝】xxx您好，{{ruleForm.Title}},{{ruleForm.SContent}} ({{selectedStoresName}})</span>
                     <span v-if="ruleForm.NoticeType==2">【预约小宝】xxx您好，停课原因:{{ruleForm.Title}}，停课时间:{{ruleForm.tkTime}}~{{ruleForm.tkendTime}}，{{ruleForm.SContent}} 。({{selectedStoresName}})。</span>
                     <span v-if="ruleForm.NoticeType==3">【预约小宝】xxx您好，{{ruleForm.Title}},{{ruleForm.SContent}} ({{selectedStoresName}})</span>
                           </div>
                        </div><br>
                           <div style="float:right;"><span>已输入<span style=" color: #409EFF;">{{Noticelen1}}</span>字符：标题（<span style=" color: #409EFF;">{{Noticelen2}}</span>）+内容（<span style=" color: #409EFF;">{{Noticelen3}}</span>），消耗<span style=" color: #409EFF;">{{ruleForm.templen}}</span>条短信</span></div>

         <span slot="footer" class="dialog-footer1">
        <el-button @click="dialogtsdxVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
    
    <el-dialog
      title="立即发布"
      :visible.sync="dialogfsqjVisible"
      width="40%"
        >
          <div class="ant-modal-body1">
                   <div>
                       <div class="form-item">
                           <label class="form-item-title">放假通知</label><br>
                           <span class="form-item-content"> {{ruleForm.Title}} <br>
                            学校：{{selectedStoresName}} <br>
                            发布时间：{{gettimes}} <br>
                            发布人：{{ruleForm.sourceName}} <br>
                            放假详情：{{ruleForm.SContent}} <br>
                           </span>
                           </div>
                           </div>
                        </div>

         <span slot="footer" class="dialog-footer1">
        <el-button @click="dialogfsqjVisible = false">关 闭</el-button>
         <!-- <el-button type="primary"  @click="dosendfj">发 送</el-button> -->

        </span>
    </el-dialog>
                     
    <el-dialog
      title="停课通知"
      :visible.sync="dialogtkVisible"
      width="40%"
        >
          <div class="ant-modal-body1">
                   <div>
                       <div class="form-item">  
                           <label class="form-item-title">停课通知</label><br>
                           <label v-if="showSelectTeacher" class="form-item-title">***你好 （<机构名称>）<br></label>
                           <label v-if="showSelectMember" class="form-item-title">***你好 （<机构名称>）<br></label>
                           <label v-if="showSelectClass" class="form-item-title">班级名称：***<br></label>
                           <span class="form-item-content"> 
                            停课原因：<停课原因> <br>
                            停课时间：<停课时间> <br>
                            备注：<备注> <br>
                            </span>
                           </div>
                           </div>
                        </div>

         <span slot="footer" class="dialog-footer1">
        <el-button @click="dialogtkVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
    <el-dialog
      title="立即发布"
      :visible.sync="dialogfstkVisible"
      width="40%"
        >
          <div class="ant-modal-body1">
                   <div>
                       <div class="form-item">
                           <label class="form-item-title">停课通知</label><br>
                           <label v-if="showSelectTeacher" class="form-item-title">***你好 （{{selectedStoresName}}）<br></label>
                           <label v-if="showSelectMember" class="form-item-title">***你好 （{{selectedStoresName}}）<br></label>
                           <label v-if="showSelectClass" class="form-item-title">班级名称：***<br></label>
                           <span class="form-item-content"> 
                            停课原因：{{ruleForm.Title}} <br>
                            停课时间：{{ ruleForm.tkTime}} <br>
                            备注：{{ruleForm.SContent}} <br>
                            </span>
                           </div>
                           </div>
                        </div>

         <span slot="footer" class="dialog-footer1">
        <el-button @click="dialogfstkVisible = false">关 闭</el-button>
         <el-button type="primary"  @click="dosendfj">发 送</el-button>

        </span>
    </el-dialog>

    <el-dialog
      :title="'选择'+WZYGName"
      :visible.sync="dialoglaoshiVisible"
      width="40%"
        >
            <el-table :data="teacherList" ref="tableData" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;" @selection-change="handleSelectionChange" >
              <el-table-column type="selection" width="55" > </el-table-column>
                 <el-table-column label="姓名" prop="Name" ></el-table-column>
                <el-table-column label="手机号" prop="Phone" ></el-table-column>

             </el-table>   
   
          <span slot="footer" class="dialog-footer1">
              <el-button type="primary"  @click="doxuanhao">确 定</el-button>
        <el-button @click="dialoglaoshiVisible = false">取 消</el-button>
        
        </span>
      
    </el-dialog>
    <el-dialog
      title="选择班级"
      :visible.sync="dialogbanjiVisible"
      width="40%"
        >
            <el-table :data="ListClass" ref="tableData2" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;" @selection-change="handleSelectionChange2" >
              <el-table-column type="selection" width="55" > </el-table-column>
                 <el-table-column label="班级名称" prop="ClassName" ></el-table-column>
                <el-table-column label="班级类型" prop="RowClassType" >
                      <template slot-scope="scope" class="flexB">
                        <span type="text" v-if="scope.row.RowClassType=='0'" >班课</span>
                        <span type="text" v-if="scope.row.RowClassType=='1'" >一对一</span>
                    </template>
                </el-table-column>

             </el-table>   
   
          <span slot="footer" class="dialog-footer1">
              <el-button type="primary"  @click="doxuanhao2">确 定</el-button>
        <el-button @click="dialogbanjiVisible = false">取 消</el-button>
        
        </span>
      
    </el-dialog>
    <el-dialog
      :title="'选择'+WZHYName"
      :visible.sync="dialogxueyuanVisible"
      width="40%"
        >
             <div class="flexB" style="margin-bottom:10px;">
       
         <div class="flexS">
                    <el-input placeholder="姓名/手机号" v-model="searchContent" @keyup.enter.native="searchClick1" style="width:70%"></el-input>&nbsp;&nbsp;
                  <el-button type="primary" size="mini" @click="searchClick1">搜索</el-button>
            </div>
             </div>
             <el-table :data="memberList" ref="tableData1" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;" @selection-change="handleSelectionChange1" >
              <el-table-column type="selection" width="55" > </el-table-column>
                 <el-table-column label="学员名称" prop="Name" ></el-table-column>
                <el-table-column label="手机号" prop="Phone" >
                </el-table-column>
             </el-table>   
       <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange3"
                    @current-change="handleCurrentChange3"
                     :current-page.sync="currentPage3"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit3"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count3">
                    </el-pagination>
        </div>
          <span slot="footer" class="dialog-footer1">
              <el-button type="primary"  @click="doxuanhao1">确 定</el-button>
        <el-button @click="dialogxueyuanVisible = false">取 消</el-button>
        
        </span>
      
    </el-dialog>
    <!-- 搜索筛选 -->
  </div>
</template>
<script>

import Pagination from "../../components/Pagination";
 import { baseUrl } from "../../config/env.js";
 import { ajax } from "../../config/fetch.js";
 import {getLoginToken} from "@/api/getData";
export default {
  data() {
    return {
              formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
      
      },
           SelectStoresID:localStorage.getItem("StoresID"),
           iscdyy:localStorage.getItem("iscdyy"),

           
        baseUrl,
                loading:false,
                searchContent:"",
                dialoglaoshiVisible:false,
                dialogxueyuanVisible:false,
                showDrawerGG:false,
                loading1:false,
                dialogtsVisible:false,
                dialogtsdxVisible:false,
                dialogfsqjVisible:false,
                dialogtkVisible:false,
                dialogfstkVisible:false,
                storeList:[],
                AnnouncementList:[],
                selectedStore:"",     
                selectedStoresName:"",           
                NoticeType:"",
                Noticelen1:0,
                Noticelen2:0,
                Noticelen3:0,
                activeName:"all",
                NoticeID:"",
                limit1: 10,
                count1:1,
                currentPage1:1,
                offset1:1,
                limit2: 10,
                count2:1,
                iswebview:1,
                currentPage2:1,
                offset2:1,
                limit3: 10,
                count3:1,
                currentPage3:1,
                offset3:1,
                sendTypeList:[
                    {
                        ID:"1",
                        TypeName:"所有"+ localStorage.getItem('WZHYName')
                    },
                    {
                        ID:"2",
                        TypeName:"选定" + localStorage.getItem('WZHYName')
                    },
                    {
                        ID:"3",
                        TypeName:"所有" + localStorage.getItem('WZYGName') 
                    },
                    {
                        ID:"4",
                        TypeName:"选定" + localStorage.getItem('WZYGName') 
                    },
                ],
                NoticeList:[],
                showDrawer:false,
                ruleForm:{
                    sendType:"1",
                    Title:"",
                    SContent:"",
                    SelectIDs:"",
                    NoticeType:1,
                    tkTime:"",
                    isPush:"0",
                    isSms:"0",
                    // sourceID:getStore("loginID"),
                    // sourceName:getStore("Name"),
                    TeacherName:"",
                    NoticeTeacher:"",
                    MemberName:"",
                    NoticeMember:"",
                    NoticeClass:"", 
                    ClassNames:"",
                    templen:0,
                    tkendTime:"",

                    
                },
                 pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
                ruleFormGG:{
                    IType:"1",
                    sendObject:"1",
                    aTitle:"",
                    aInfo:"",
                    // sendID:getStore("loginID"),
                    StoresID:""
                },
                rulesGG:{
                    aInfo: [{required:true, message:'请输入内容', trigger:'blur'}],
                    aTitle: [{required: true, message:'请输入标题', trigger: 'blur' }],
         
                },
                showSelectTeacher:false,
                showSelectMember:false,
                showSelectClass:false,
                dialogbanjiVisible:false,
                options:[
                    {value:"1",label:"王老师"},
                    {value:"2",label:"陈老师"},
                ],
                teacherList:[],
                memberList:[],
                ListClass:[],
                rules:{
                    sendType: [{required:true, message:'', trigger:'change'}],
                    Title: [{required: true, message:'请输入标题', trigger: 'blur' }],
           
                },
                canSend:true,
                // iswebview:getStore("iswebview"),
                gettimes:"",
                multipleSelection:[],
                multipleSelection1:[],
                cmultipleSelection1:[],
                multipleSelection2:[],
                Limits:[],
                q1:false,
                q2:false,
                q3:false,
                q4:false,
                q5:false,
                q6:false,
                    WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
            };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
        if(localStorage.getItem('isAdmin') == 1){
          
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 =true
   
      }
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {

            if(items == 102)
            this.q1  =true
            if(items == 103)
            this.q2 = true
            if(items == 104)
            this.q3 = true
            if(items == 105)
            this.q4 = true
            if(items == 106)
            this.q5 = true
            if(items == 101){
              this.q6 = true
            }

      })
      
      if(this.q6 == false && this.q3 == true){
        this.activeName = 'gg'
        this.getListAnnouncement()
      }
        this.getDianList()
        this.getList()
    // this.getdata(this.formInline);
    // this.getLoginToken()
    //  const loading = this.$loading({
    //       lock: true,
    //       text: '加载中...',
    //       spinner: 'el-icon-loading',
    //       background: 'rgba(0, 0, 0, 0.7)'
    //     });
    //     // setTimeout(() => {
    //     //   loading.close();
    //     // }, 2000);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    computedByteLen(txt) {
              return txt.length
                // return txt.replace(/[^\x00-\xff]/g, '01').length
        },
    mobandxinfo(ruleForm){
       
          if(this.ruleForm.NoticeType ==1 || this.ruleForm.NoticeType==3){
                  var str = '【预约】xxx您好，';
                  var str1 =  this.ruleForm.Title+'，';
                  var str2 =  this.ruleForm.SContent+'('+this.selectedStoresName+')';
                    this.Noticelen1 = this.computedByteLen(str+str1+str2);
                    this.Noticelen2 = this.computedByteLen(str+str1);
                    this.Noticelen3 = this.computedByteLen(str2);
                    if(this.Noticelen1<=70){

                        this.ruleForm.templen =1;
                    }else{
                        this.ruleForm.templen =parseInt(this.Noticelen1 /70)+1;
                    }
                }else{
                  var str = '【预约小宝】xxx您好，';
                  var str1 =  this.ruleForm.Title+'，';
                  var str2 =  '停课时间:'+this.ruleForm.tkTime +'~'+this.ruleForm.tkendTime+'，'+this.ruleForm.SContent+'('+this.selectedStoresName+')';
                    this.Noticelen1 = this.computedByteLen(str+str1+str2);
                    this.Noticelen2 = this.computedByteLen(str+str1);
                    this.Noticelen3 = this.computedByteLen(str2);
                    if(this.Noticelen1<=70){

                        this.ruleForm.templen =1;
                    }else{
                        this.ruleForm.templen =parseInt (this.Noticelen1 /70) +1;
                    }

                }
                  
                this.dialogtsdxVisible = true

    },
    deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:row.ID,
        
        }
        var that = this
        this.ajax('delStaff.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
 
        });
   
    },
    
    deletNoticeClick(item){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { 
            SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
            NoticeType:item.sendType,
            NoticeID:item.ID,
    
        }
        var that = this
        this.ajax('deletNotice.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
             that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
 
        });
   
    },
    deletAnnouncementClick(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { 
            SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
        AnnouncementID:row
        
        }
        var that = this
        this.ajax('deletAnnouncement.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
             that.getListAnnouncement()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
 
        });
   
    },
      unique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.ID) && res.set(arr.ID, 1));
      },
      toggleSelection1 (rows) {
                 let arr = []
                 let allPermission = this.ruleForm.NoticeMember.split(',');
 
                 rows.forEach(item => {
                    allPermission.forEach(element =>{
            

                 if (element === item.ID) {
                       arr.push(item)
                    }
                   })
                })
 
             if (arr) {
                   this.$nextTick(() => {
               arr.forEach(row => {
                 this.$refs.tableData1.toggleRowSelection(row,true);
              });
              })
                } else {
                 this.$refs.tableData1.clearSelection()
                }
            },
      getMemberOptions(){
                var data= {
                    StoresID:this.selectedStore,
                    selectName:this.searchContent,
                    SelectStoresID:this.SelectStoresID,
                    token: localStorage.getItem("token"),
                    StoresID:localStorage.getItem("StoresID"),
                    pages:this.offset3,//当前页
                    psize:this.limit3,//一页几条
                    MembersType:1,
                }
                var that = this
                this.ajax('getListMembers.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {
                     that.memberList = res.data;
                    that.count3 = res.allcount;
                     that.dialogxueyuanVisible =true;
                            that.toggleSelection1(res.data)
                        }else{
                            that.$message({ type: "error", message: res.Msg ,duration:1000});
                        }
                
                })      
            },
      addMemberIDs(){
                   this.currentPage3 = 1;
                    this.offset3 = 1;
                    this.getMemberOptions();
                 
    },
      onSend(formName){
          this.$refs[formName].validate(async valid => {
                    if (valid) {
                       
                            this.addNotice();

                        
                        
                    } else {
                        return false;
                    }
                });
      },
      addNotice(){
           if(this.showSelectTeacher){
                    this.ruleForm.SelectIDs = this.ruleForm.NoticeTeacher;
                }
                if(this.showSelectMember){
                    this.ruleForm.SelectIDs = this.ruleForm.NoticeMember;
                }
                if(this.showSelectClass){
                    this.ruleForm.SelectIDs = this.ruleForm.NoticeClass;
                }
                if(this.ruleForm.tkTime==''&& this.ruleForm.NoticeType==2){
                   this.$message({ type: "error", message: "请选择停课时间" ,duration:1000});
                        return;
                }
                   var that = this
                   this.loading1 = true;
                   var data = {
                     SelectStoresID:this.SelectStoresID,
                    token: localStorage.getItem("token"),
                    StoresID:localStorage.getItem("StoresID"),
                    sendType: this.ruleForm.sendType,
                    Title: this.ruleForm.Title,
                    SContent: this.ruleForm.SContent,
                    SelectIDs: this.ruleForm.SelectIDs,
                    NoticeType: this.ruleForm.NoticeType,
                    tkTime: this.ruleForm.tkTime,
                    tkendTime: this.ruleForm.tkendTime,
                    isPush: this.ruleForm.isPush,
                    isSms: this.ruleForm.isSms,
                    sourceID:localStorage.getItem("LoginID"),
                    sourceName:localStorage.getItem("Name"),
                    templen: this.ruleForm.templen
                }
                     
       this.ajax('addNotice.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.loading1 = false;
               that.dialogfsqjVisible = false;
               that.dialogfstkVisible = false;
                that.dialogtsVisible = false
                that.dialogtsdxVisible = false
                that.showDrawer = false
               that.getList()

            //    that.NoticeList =res.data
            //    that.pageparm.total = res.allcount
               
            }

        })    
      },
      doxuanhao2(){
                let arr = [];
                let arrname = [];
                this.multipleSelection2.forEach(element => {
                    arr.push(element.ID);
                    arrname.push(element.ClassName);
                });
                 if(arr.length>0){
                          
                         this.ruleForm.NoticeClass = arr.join();
                         this.ruleForm.ClassNames= arrname.join();
 
                   
                  
                }else{
                    
                         
                         this.ruleForm.NoticeClass="";
                         this.ruleForm.ClassNames= "";
 
                    
                }
             

                    this.dialogbanjiVisible =false;
               
                 
            },
                  searchClick1(){
              this.currentPage3 = 1;
                    this.offset3 = 1;
                    this.getMemberOptions();
      },handleSelectionChange1(val){
                  val.forEach(element => {
                    this.cmultipleSelection1.push(element);
                });
                 this.multipleSelection1=this.unique(this.cmultipleSelection1);


            },getTimes(){
       let yy = new Date().getFullYear();
      var mm =
        new Date().getMonth() < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      var dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      this.gettimes = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;

        },
        doxuanhao1(){
                let arr = [];
                let arrname = [];
                this.multipleSelection1.forEach(element => {
                    arr.push(element.ID);
                    arrname.push(element.Name);
                });
                 if(arr.length>0){
                          
                         this.ruleForm.NoticeMember = arr.join();
                         this.ruleForm.MemberName= arrname.join();
 
                   
                  
                }else{
                    
                         
                         this.ruleForm.NoticeMember="";
                         this.ruleForm.MemberName= "";
 
                    
                }
             

                    this.dialogxueyuanVisible =false;
               
                 
            },
              handleCurrentChange3(val) {
        this.currentPage3 = val;
        this.offset3 =val;
        this.getMemberOptions()
      },
        handleSizeChange3(val){
        this.limit3 = val;
        this.currentPage3 = 1;
        this.offset3 = 1;
        this.getMemberOptions();
      },
      handleSelectionChange2(val){
                this.multipleSelection2 = val;

            },
      doxuanhao(){
                let arr = [];
                let arrname = [];
                this.multipleSelection.forEach(element => {
                    arr.push(element.ID);
                    arrname.push(element.Name);
                });
                 if(arr.length>0){
                          
                         this.ruleForm.NoticeTeacher = arr.join();
                         this.ruleForm.TeacherName= arrname.join();
 
                   
                  
                }else{
                    
                         
                         this.ruleForm.NoticeTeacher="";
                         this.ruleForm.TeacherName= "";
 
                    
                }
             

                    this.dialoglaoshiVisible =false;
               
                 
            },
            // getListStaff
            getTeacherOptions(){
var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:0
      }
        var that = this
      this.ajax('getListStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.teacherList = res.data;
                that.dialoglaoshiVisible =true;
                that.toggleSelection(that.teacherList);
          } 

      })
            },
            toggleSelection (rows) {
                 let arr = []
                 let allPermission = this.ruleForm.NoticeTeacher.split(',');
 
                 rows.forEach(item => {
                    allPermission.forEach(element =>{
            

                 if (element === item.ID) {
                       arr.push(item)
                    }
                   })
                })
 
             if (arr) {
                   this.$nextTick(() => {
               arr.forEach(row => {
                 this.$refs.tableData.toggleRowSelection(row,true);
              });
              })
                } else {
                 this.$refs.tableData.clearSelection()
                }
            },
      addeacherIDs(){
                //this.TeacherIDs = this.ruleForm.TeacherIDs;
                 this.getTeacherOptions();
                 
            },handleSelectionChange(val){
                this.multipleSelection = val;

            },
       dosendfj(){
               this.addNotice();
            },
       changeOptions(val){
            
                if(val==4){
                    this.showSelectTeacher = true;
                        this.multipleSelection1=[]
                        this.cmultipleSelection1=[]
                        this.multipleSelection2=[]
                  //  this.getTeacherOptions();
                }else{
                    this.showSelectTeacher = false;
                    
                }
                if(val==2){
                    this.showSelectMember = true;
                    this.multipleSelection=[]
                    this.multipleSelection2=[]

                   // this.getMemberOptions();
                }else{
                    this.showSelectMember = false;
                }
                if(val==6){
                    this.showSelectClass = true;
                    this.multipleSelection=[]
                    this.multipleSelection1=[]
                    this.cmultipleSelection1=[]
                   // this.getallListClass();
                }else{
                    this.showSelectClass = false;
                }
            },
       sendNotice(){
                this.showDrawer = true;
                this.showSelectTeacher = false;
                this.showSelectMember = false;
                this.showSelectClass = false;
                this.ruleForm={
                    sendType:"1",
                    Title:"",
                    SContent:"",
                    SelectIDs:"",
                    NoticeType:1,
                    tkTime:"",
                    isPush:"0",
                    isSms:"0",
                    // sourceID:getStore("loginID"),
                    // sourceName:getStore("Name"),
                    TeacherName:"",
                    NoticeTeacher:"",
                    MemberName:"",
                    NoticeMember:"",
                    NoticeClass:"", 
                    ClassNames:"",
                    templen:0,
                    tkendTime:""
                }
            },
        getListAnnouncement(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
           pages:this.formInline.page,
          psize:this.formInline.limit,
      }
      const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        var that = this
       this.ajax('getListAnnouncement.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.AnnouncementList =res.data
               that.pageparm.total = res.allcount
               that.AnnouncementList.forEach(items => {
                 items.addTime = items.addTime.replace(/\//g, '-')
               });
               
            }
            loading.close();

        })    

        },
     onSendgg(formName){
                this.$refs[formName].validate(async valid => {
                    if (valid) {
                        this.addAnnouncement();
                    } else {
                        return false;
                    }
                });
            },
            addAnnouncement(){
            var data = this.ruleFormGG
            var that = this
            this.ajax('addAnnouncement.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.getListAnnouncement()
               that.loading1 = false;
             that.showDrawerGG = false;
            //    that.NoticeList =res.data
            //    that.pageparm.total = res.allcount
               
            }

        })    

            },
    sendGG(){
            this.ruleFormGG={
                    IType:"1",
                    sendObject:"1",
                    aTitle:"",
                    aInfo:"",
                    token: localStorage.getItem("token"),
                    sendID:localStorage.getItem("loginID"),
                    StoresID:localStorage.getItem("StoresID"),
                    SelectStoresID:this.SelectStoresID,
                }
                 this.showDrawerGG = true;

            },
       handleClick(tab, event) {
                // console.log(tab, event);
                if(tab.name == "all"){
                     this.currentPage1 = 1;
                    this.offset1 = 1;
                    this.getList();
                 }else if(tab.name == "gg"){
                      this.currentPage2 = 1;
                    this.offset2 = 1;
                 this.getListAnnouncement();
                }
            },
    getList(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
           pages:this.formInline.page,
          psize:this.formInline.limit,
      }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getListNotice.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.NoticeList =res.data
               that.NoticeList.forEach(items => {
                 items.addTime = items.addTime.replace(/\//g, '-')
               });
               that.pageparm.total = res.allcount
               
            }
            loading.close();

        })    
    },
    // getList(){
    //     var data = { 
    //       SelectStoresID:this.SelectStoresID,
    //       token: localStorage.getItem("token"),
    //       StoresID:localStorage.getItem("StoresID")
    //   }
    //     var that = this
    //    this.ajax('getHomeInfo.aspx',JSON.stringify(data),"POST",function(res){

    //        if (res.orsuccess == "1") {
    //            that.list =res.data
               
    //         }

    //   })
    // },
    changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.DianList.forEach(items => {
        if(items.ID == this.SelectStoresID){
          this.selectedStoresName = items.StoresName
        }
      });
      this.getList()
      // this.getImg()
    },
      getDianList(){
       var data = { 
          SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               that.DianList.forEach(items => {
                 if(items.ID == that.SelectStoresID){
                   that.selectedStoresName = items.StoresName
                 }
               });
            }

      })
    },
 
 
  
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
     if(this.activeName == "all"){
                     this.currentPage1 = 1;
                    this.offset1 = 1;
                    this.getList();
                 }else if(this.activeName == "gg"){
                      this.currentPage2 = 1;
                    this.offset2 = 1;
                 this.getListAnnouncement();
        }
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          deptSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
  
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("公司保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deptDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("公司删除失败，请稍后再试！");
            });
        })
        .catch(() => {
            ;
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>
<style scoped>
.rankingList___2qU5M li span:last-child {
    float: right;
}
.rankingList___2qU5M li span.active___3n5dI {
    background-color: #fab938 !important;
    color: #fff !important;
}
.rankingList___2qU5M li span:first-child {
    background-color: #f5f5f5;
    border-radius: 20px;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    margin-right: 10px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    color:black;
}
.rankingList___2qU5M li{
    zoom: 1;
    margin-top: 16px;
}
.rankingList___2qU5M li span {
    color: rgba(0,0,0,.65);
    font-size: 12px;
    line-height: 22px;
}
.rankingList___2qU5M {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    height: 300px;
    overflow:auto;
}
.bottomTitle{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    line-height: 20px;
}
.bottomTitle1{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    /* line-height: 20px; */
}
.rmb{
  font-size: 12px; line-height: 1;
}
.money{
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    margin-top: 12px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
}
.textTitle{
    margin-right: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
    line-height: 22px;
}
 .box{
    cursor: pointer;
    width: 24%;
    height: 160px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .box1{
 
    width: 74.7%;
    height: 362px;
    /* padding: 20px; */
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    /* border: 1px solid #ececec; */
    /* box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%); */
  }
  .box2{
    cursor: pointer;
    width: 24%;
    height: 362px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .pm{
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: "tnum";
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0,0,0,.85);
    font-weight: 500;
  }

 .box3{
    cursor: pointer;
    width: 24%;
    height: 130px;
    
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box3Ttile{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
  }
  .num{
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
  }
   .box4{
    cursor: pointer;
    width: 24%;
    height: 100px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
   border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
 .box5{
    cursor: pointer;
    height: 200px;
    width:180px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
</style>

 



// WEBPACK FOOTER //
// src/views/notice/notice.vue